import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

/**
 * Guard que restringe acesso a rotas exclusivas de usuarios contadores.
 * Verifica o flag salvo no sessionStorage/localStorage durante o login.
 */
export const contadorAccessGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return router.createUrlTree(['/sem-permissao']);
  }

  const isContador =
    sessionStorage.getItem('contador') === 'true' ||
    localStorage.getItem('contador') === 'true';

  return isContador ? true : router.createUrlTree(['/sem-permissao']);
};
